import React from 'react';

import { Button as ChakraButton, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled';

// import { Link } from '@chakra-ui/react';
import { MyGoals } from 'assets/assetsV1/iconComponents';

import { NotificationBadge } from 'uiToolkitV1/NotificationBadge';
import { TextLabel } from 'uiToolkitV1/Typography';

const TransientProps = [
  'size',
  'isIconOnlyButton',
  'isLeftIcon',
  'buttonColor',
  'isRightIcon',
  'withBackground',
  'isDropdown',
];

export const SIDE_PANEL_BUTTON_SIZE = {
  SMALL: 'small',
  LARGE: 'large',
};

const getBaseButtonStyles = (theme, props) => ({
  boxShadow: props?.boxShadow ?? 'none !important', // <- important to remove from active state of button

  textTransform: 'none',
  padding: 0,
  borderRadius: '8px', // <- need to discuss button size
  border: 0,
  minWidth: 'auto',

  '& .chakra-button__icon': {
    margin: '0',
  },
  '&:hover:enabled ': {
    cursor: 'pointer',
    p: {
      fontWeight: '590',
    },
  },
});

const StyledSidePanelButton = styled(ChakraButton, {
  shouldForwardProp: (prop) => !TransientProps.includes(prop),
})(({ theme, ...props }) => ({
  ...getBaseButtonStyles(theme, props),
  height: '80px',
  width: '80px',
  display: 'inline-block',

  backgroundColor: 'transparent',
  '&>p': {
    color: theme.colors.text.g2,
  },
  '&:active:enabled': {
    backgroundColor: 'transparent',
  },
  '& svg': {
    color: theme.colors.text.g2,
  },
  '&:hover:enabled, &.hovering ': {
    backgroundColor: '#F6FAFE',

    cursor: 'pointer',
    '&>p': {
      color: theme.colors.button.blue.hover,
    },
    '& svg': {
      color: theme.colors.button.blue.hover,
    },
  },
  '&:active:enabled, &.active-styles': {
    backgroundColor: theme.colors.surface.E6F1FD,
    '&>p': {
      color: theme.colors.button.blue.focus,
      fontWeight: 600,
    },
    '& svg': {
      color: theme.colors.button.blue.focus,
    },
  },
}));

const StyledSidePanelButtonSmall = styled(StyledSidePanelButton, {
  shouldForwardProp: (prop) => !TransientProps.includes(prop),
})(() => ({
  height: '56px',
  width: '56px',
  flex: 'auto 0 0',
  textWrap: 'wrap',
  '.chakra-text': {
    fontSize: '10px !important',
    lineHeight: '12px !important',
  },
}));

export const SidePanelButton = ({
  selected = false,
  onClick,
  className = '',
  Icon = MyGoals,
  children,
  iconSize = '24px',
  startIconProps,
  notificationCount,
  size = SIDE_PANEL_BUTTON_SIZE.LARGE,
  ...props
  /* missing notification count prop and implementation, use notification badge component */
}) => {
  const theme = useTheme();
  const IconComp = <Icon color={theme.colors.icon.white} boxSize={iconSize} {...startIconProps} />;

  const StyledButton = size === SIDE_PANEL_BUTTON_SIZE.SMALL ? StyledSidePanelButtonSmall : StyledSidePanelButton;

  return (
    <NotificationBadge notificationCount={notificationCount} transform="translate(-15px, 10px)">
      <StyledButton
        onClick={onClick}
        leftIcon={IconComp}
        className={selected ? `${className} active-styles` : className}
        {...props}
      >
        <TextLabel bold={selected}>{children}</TextLabel>
      </StyledButton>
    </NotificationBadge>
  );
};
